import { Injectable, isDevMode } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { cmsData } from '../test/cmslabel.mock';
import { IState } from '../utils/state.interface';
@Injectable({
  providedIn: 'root',
})
export class StateService {
  state: IState = null;
  constructor() {
    if (isDevMode()) {
      this.state = cmsData as IState;
    } else {
      const stateData = (<HTMLInputElement>(
        document.getElementById('my-app-state')
      )).innerText
        .replace(new RegExp('&q;', 'g'), '"')
        .replace(new RegExp('&a;', 'g'), '&')
        .replace(new RegExp('&s;', 'g'), "'")
        .replace(new RegExp('&l;', 'g'), '<')
        .replace(new RegExp('&g;', 'g'), '>');
      this.state = JSON.parse(stateData);
    }
  }
  public showBannerComp = new BehaviorSubject(true);
}
